import useTranslation from '../../hooks/useTranslation';
import { useEffect, useRef } from 'react';

import useSelectField from 'hooks/useSelectField';

import type { FieldValues, Props } from './types';

const useData = <T extends FieldValues>({
    clientId,
    control,
    isOpen,
    isRequired = false,
    name,
    onPanelClose,
    onPanelOpen,
    ref
}: Props<T>) => {
    const prevClientIdRef = useRef<string | undefined>(clientId ?? undefined);
    const { FARM_IS_REQUIRED } = useTranslation();

    const selectField = useSelectField<T>({
        control,
        isOpen,
        isRequired,
        name,
        onPanelClose,
        onPanelOpen,
        ref,
        requiredMessage: isRequired ? FARM_IS_REQUIRED : false
    });

    const { onChange } = selectField;

    useEffect(() => {
        const prevClientId = prevClientIdRef.current;

        if (prevClientId !== undefined && clientId !== prevClientId) {
            onChange(undefined);
        }

        prevClientIdRef.current = clientId ?? undefined;
    }, [clientId, onChange]);

    return selectField;
};

export default useData;
